// @ts-nocheck
/* eslint-disable */
import { setItem, getItem } from "~/es6/localstorage";

Mapy.CML = (function() {
	const LS_KEY = "mapyczCML";

	class CML {
		constructor() {
			this._state = {};
			this._listeners = [];
		}

		/**
		 * Smazani - nastaveni def. stavu
		 */
		destroy() {
			this._state = {};
			this._listeners = [];
		}

		/**
		 * Ziskani kopie stavu.
		 */
		get state() {
			return JSON.parse(JSON.stringify(this._state));
		}

		/**
		 * Nastaveni noveho stavu. Pokud neni zmena, neprovede se volani na posluchace.
		 * Pokud bude v objektu jiny klic nez v DEF_STATE, nic se nanastavi.
		 * Nastavujeme jako klic: hodnota { klic: hodnota }
		 *
		 * @param   {Object}  newObj Novy stav
		 */
		set state(newObj) {
			let diffObj = this._applyChanges(this._state, newObj);
			let diffKeys = Object.keys(diffObj);

			if (diffKeys.length) {
				this._callAllListeners(diffObj);
			}
		}

		/**
		 * Pridani posluchace pro zmeny stavu.
		 *
		 * @param   {Function}  cb  Fn(cely stav, objekt se zmenamy)
		 * @param   {String}  [path] Cesta pro sledovani zmen v objektu
		 * @return  {String}
		 */
		addListener(cb, path) {
			let id = Math.random().toString(16);

			this._listeners.push({ id, cb, path });

			return id;
		}

		/**
		 * Odstraneni posluchace s ID.
		 *
		 * @param   {String}  id
		 */
		removeListenerId(id) {
			for (let i = this._listeners.length - 1; i >= 0; i--) {
				let item = this._listeners[i];

				if (item.id == id) {
					this._listeners.splice(i , 1);
					break;
				}
			}
		}

		/**
		 * Odstraneni posluchacu.
		 *
		 * @param   {Array[String]}  ids - pole id
		 */
		removeListeners(ids) {
			while (ids.length) {
				let id = ids.pop();
				this.removeListenerId(id)
			}
		}

		/**
		 * Ulozeni aktualniho stavu do local storage.
		 */
		save() {
			setItem(LS_KEY, JSON.stringify(this._state));
		}

		/**
		 * Nahrani stavu z localstorage do pameti.
		 */
		restore() {
			let newObj = {};

			try {
				newObj = JSON.parse(getItem(LS_KEY) || "{}");
			}
			catch (ex) {}

			let diffObj = this._applyChanges(this._state, newObj);
			let diffKeys = Object.keys(diffObj);

			if (diffKeys.length) {
				this._callAllListeners(diffObj, true);
			}
		}

		/**
		 * Obvolani vsech posluchacu.
		 *
		 * @param   {Object}  diffObj
		 * @param   {Boolean} [fromRestore] Jedna se o nastaveni z restore?
		 */
		_callAllListeners(diffObj, fromRestore) {
			// aktualni novy stav
			for (let i = 0; i < this._listeners.length; i++) {
				let l = this._listeners[i];
				// globalni stav
				if (!l.path) {
					l.cb(this.state, fromRestore);
				}
				else if (l.path && l.path in diffObj) {
					let state = this.state;
					l.cb(Mapy.Util.getObjValue(state, l.path), state, fromRestore);
				}
			}
		}

		/**
		 * Aplikovai  zmen: mam objekt source, diff je taky objekt, pouze zmeny se prenesou z diff -> source, vygeneruje se diffs objekt,
		 * ktery obsahuje seznam zmenenych cest - takze:
		 *
		 * source = { route: { a: 5 }}; diff = { route: { a: 5 }} -> nic se naplikuje, diff je {}
		 * source = { route: { a: 5 }}; diff = { route: { a: 6 }} -> aplikuje se zmena, diff je { "route": 1, "route.a": 1 }
		 * ...
		 *
		 * @param   {Object}  source Vstupni objekt
		 * @param   {Object}  diff Zmeny
		 * @param   {Array}  path Aktualni cesta - zanoreni
		 * @param   {Object}  diffs Seznam zmen
		 * @return  {Object} diffs
		 */
		_applyChanges(source, diff, path, diffs) {
			// def. parametry
			if (typeof path === "undefined") {
				path = [];
			}

			if (typeof diffs === "undefined") {
				diffs = {};
			}

			if (typeof diff === "object" && !Array.isArray(diff) && diff) {
				// objekt
				let objKeys = Object.keys(diff);

				for (let i = 0; i < objKeys.length; i++) {
					let key = objKeys[i];

					if (!source) {
						let lastPath = path[path.length - 1];

						if (Array.isArray(diff)) {
							source = [];
						}
						else if (typeof diff === "object" && !Array.isArray(diff)) {
							source = {};
						}

						if (lastPath.type == "object") {
							lastPath.value[lastPath.key] = source;
						}
						else {
							lastPath.value[lastPath.ind] = source;
						}
					}

					let newPath = path.concat({ type: "object", key, value: source });

					if (!(key in source)) {
						source[key] = Array.isArray(diff[key]) ? [] : {};
						this._applyDiff(newPath, diffs);
					}

					this._applyChanges(source[key], diff[key], newPath, diffs);
				}
				// predtim plny objekt, teda prazdny
				if (objKeys.length == 0 && (source === null || Object.keys(source).length)) {
					this._applyDiff(path, diffs);
				}
			}
			else if (typeof diff === "object" && Array.isArray(diff)) {
				let len = diff.length;

				// upravime delky poli
				if (Array.isArray(source) && source.length != len) {
					source.length = len;
					this._applyDiff(path, diffs);
				}

				for (let i = 0; i < len; i++) {
					if (!source && typeof diff === "object") {
						let lastPath = path[path.length - 1];

						if (Array.isArray(diff)) {
							source = [];
						}
						else if (typeof diff == "object" && !Array.isArray(diff)) {
							source = {};
						}

						if (lastPath.type == "object") {
							lastPath.value[lastPath.key] = source;
						}
						else {
							lastPath.value[lastPath.ind] = source;
						}
					}

					this._applyChanges(source[i], diff[i], path.concat({ type: "array", ind: i, value: source }), diffs);
				}

				// predtim plne pole, teda prazdne
				if (!len && (source === null || source.length)) {
					this._applyDiff(path, diffs);
				}
			}
			else {
				if (source != diff) {
					let lastPath = path[path.length - 1];

					switch (lastPath.type) {
						case "object":
							lastPath.value[lastPath.key] = diff;
							break;

						case "array":
							lastPath.value[lastPath.ind] = diff;
							break;
					}

					this._applyDiff(path, diffs);
				}
			}

			return diffs;
		}

		/**
		 * Aplikovani diffu z cesty.
		 *
		 * @param   {Array}  path Zmenena cesta
		 * @param   {Object}  diffs Vystupni diff objekt
		 */
		_applyDiff(path, diffs) {
			let items = [];

			for (let i = 0, max = path.length; i < max; i++) {
				let pathItem = path[i];

				if (pathItem.type == "object") {
					items.push(pathItem.key);
				}
				else if (pathItem.type == "array" && items.length) {
					items[items.length - 1] += `[${pathItem.ind}]`;
				}

				diffs[items.join(".")] = 1;
			}
		}
	}

	return new CML();
})();
